/* eslint-disable */
// @ts-nocheck

import { Icon } from '@lmc/ui-kit'
import React from 'react'

/**
@description Renders a HelpLink

@param {bool} displayText. Toggles whether to display any text.

@param {object} style. Optional style object.

@param {string} supportLink. Link to support article.

@param {string} text. Optional text string. Default is 'Help'.

@returns {function} HelpLink.
*/

interface HelpLinkProps {
  displayText?: boolean
  style?: React.CSSProperties
  supportLink: string
  text?: string
}

type Props = HelpLinkProps

const HelpLink = ({
  displayText = true,
  style,
  supportLink,
  text = 'Help'
}: Props) => {
  return (
    <React.Fragment>
      <a
        className={'lmc-glyph-link'}
        href={supportLink}
        rel="noreferrer"
        style={style}
        target={'_blank'}
      >
        <Icon name="QuestionOutlined" style={{ paddingRight: 6 }} />
        {displayText && text}
      </a>
    </React.Fragment>
  )
}

export default HelpLink
